import React, {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import Select from 'react-select'
import moment from 'moment'
import Swal from 'sweetalert2'
import {Tr} from '../../../_metronic/i18n/Tr'

interface BookingDetailsHeaderProps {
  bookingId: string // Assuming bookingId is of type string, adjust as needed
  bookingdetailId: string // Assuming bookingId is of type string, adjust as needed
}

const BookingDetail: React.FC<BookingDetailsHeaderProps> = ({bookingId, bookingdetailId}) => {
  let t = Tr()
  const {menuId} = useMenuIdPermissions()

  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState<any>([])
  const [selectedTour, setSelectedTour] = useState<any>([])

  const [tourList, setTourList] = useState([])
  const [tourpackageId, settourpackageId] = useState('')
  const [toursId, setToursId] = useState('')
  const [detailBookingId, setDetailBookingId] = useState('')

  const [statusList] = useState([
    {value: '0', label: 'Pending'},
    {value: '1', label: 'Approved'},
    {value: '2', label: 'Rejected'},
    {value: '3', label: 'Cancelled'},
    // {value: '4', label: 'Completed'},
  ]) as any

  const [adult, setAdult] = useState('')
  const [infant, setInfant] = useState('')
  const [child, setChild] = useState('')
  const [quantity, setQuanity] = useState('')
  const [fromDate, setFromFDate] = useState('')

  const formatDate = (date: any) => {
    if (date == null || date == '') {
      var today: any = new Date()
      var date: any = moment(today).format('yyyy-MM-DD')
      return date
    }
    return moment(date).format('yyyy-MM-DD')
  }

  const editBookingDetails = async () => {
    setDisable(true)
    setLoading(true)
    let swalOptions: any

    if (selectedStatus.value == 2 || selectedStatus.value == 3) {
      if (selectedStatus.value == '2') {
        swalOptions = {
          title: t('Are You Sure? You Want to Reject This Booking.'),
          icon: 'warning',
          showCancelButton: true,
          input: 'text',
          inputLabel: 'Reason',
          inputPlaceholder: t('Enter Reject Reason'),
          inputValidator: (value: any) => {
            if (!value) {
              return t('Reject Reason Required!')
            }
          },
        }
      } else if (selectedStatus.value == '3') {
        swalOptions = {
          title: t('Are You Sure? You Want to Cancel This Booking.'),
          icon: 'warning',
          showCancelButton: true,
          input: 'text',
          inputLabel: 'Reason',
          inputPlaceholder: t('Enter Cancel Reason'),
          inputValidator: (value: any) => {
            if (!value) {
              return t('Cancel Reason Required!')
            }
          },
        }
      }
    }

    const updateBooking = async (inputValue = null) => {
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }

      var param: any = {
        updateStatus: '1',
        bookingId: String(bookingId),
        bookingdetailId: bookingdetailId,
        bookingDetailStatus: selectedStatus ? selectedStatus.value : '',
        adminId: adminId,
        quantity: String(quantity),
        adult: adult == '' ? '0' : String(adult),
        child: child == '' ? '0' : String(child),
        infant: infant == '' ? '0' : String(infant),
        fromDate: formatDate(fromDate),
      }

      let param2: {[key: string]: any} = {
        bookingId: bookingId,
        adminId: adminId,
        reason: inputValue,
        status: selectedStatus.value,
      }
      if (selectedStatus.value == 3) {
        param2.bookingdetailId = bookingdetailId
        param2.cancellationDate = moment().format('YYYY-MM-DD HH:mm:ss.SSZZ')
        var res2 = await fetchData('admin/cancelbooking', param2)
      } else if (selectedStatus.value == 2) {
        var res3 = await fetchData('admin/rejectbooking', param2)
        var res4 = await fetchData('admin/approverejectbooking', param2)
      }

      if (selectedStatus.value == 2) {
        if (res3.status == '200') {
          toastsuccessmsg(res3.message)
        } else {
          toasterrormsg(res3.message)
        }
      }

      if (selectedStatus.value == 2) {
        if (res4.status == '200') {
          toastsuccessmsg(res4.message)
        } else {
          toasterrormsg(res4.message)
        }
      }

      if (selectedStatus.value == 3) {
        if (res2.status == '200') {
          toastsuccessmsg(res2.message)
        } else {
          toasterrormsg(res2.message)
        }
      }

      if (selectedStatus.value != 2 && selectedStatus.value != 3) {
        var res = await fetchData('admin/edittourpackagebooking', param)
      }
      if (selectedStatus.value != 2 && selectedStatus.value != 3) {
        if (res.status == '200') {
          setDisable(false)
          setLoading(false)
          BookingListApiCall()
          toastsuccessmsg('Updated Successfully')
        } else {
          setDisable(false)
          setLoading(false)
          toasterrormsg(res.message)
        }
      }
    }

    if (swalOptions) {
      Swal.fire(swalOptions).then(async (result) => {
        if (result.isConfirmed) {
          await updateBooking(result.value)
        }
      })
    } else {
      // For other statuses (like approval), update directly without Swal
      await updateBooking()
    }
  }

  const BookingListApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '5',
    }

    var res = await fetchData('admin/bookingdetail', param)

    if (res.status == '200') {
      var data = res.data[0]
      setDetailBookingId(data.bookingId)

      var bookingDetail = data.bookingDetail.find(
        (item: any) => item.bookingdetailId == bookingdetailId
      )
      settourpackageId(bookingDetail.actionDetail[0].tourpackageId)
      setToursId(bookingDetail.actionTypeDetail[0].toursId)

      if (bookingDetail.status == '') {
        setSelectedStatus({value: '0', label: 'Pending'})
      } else {
        var selectedStatus = statusList.filter((item: any) => item.value == bookingDetail.status)
        setSelectedStatus(selectedStatus)
      }

      setAdult(bookingDetail.adult)
      setChild(bookingDetail.child)
      setInfant(bookingDetail.infant)
      setQuanity(bookingDetail.quantity)
      setFromFDate(formatDate(bookingDetail.fromDate))
    } else {
    }
  }

  const tourDetailListApiCall = async () => {
    var param: any = {
      tourpackageId: String(tourpackageId),
    }
    var response: any = await fetchData('vendor/public/tourpackageDetails', param)
    if (response.status == '200') {
      var tourList = response.data[0]['toursDetail']
      var opt: any = []
      tourList.map((val: any) => {
        opt.push({value: val.toursId, label: val.en_name})
      })

      setTourList(opt)
      var selectedTour = opt.filter((item: any) => item.value == toursId)
      setSelectedTour(selectedTour[0])
    } else {
    }
  }

  useEffect(() => {
    BookingListApiCall()
  }, [])

  useEffect(() => {
    tourDetailListApiCall()
  }, [tourpackageId])

  const [error, setError] = useState([
    {
      roomType: '',
      bedType: '',
      room: '',
      fromDate: '',
      toDate: '',
      quantity: '',
      fromTime: '',
      toTime: '',
    },
  ])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Edit Booking Details')}</PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          <div className='form d-flex flex-column flex-lg-row'>
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              <div className='tab-content'>
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    <div className='card card-flush py-4'>
                      <div className='card-header d-flex'>
                        <div className='card-title'>
                          <h2>{t('Booking Details')}</h2>
                        </div>
                      </div>

                      <div className='card-body pt-0'>
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t('Quantity')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='quantity'
                              placeholder={t('Quantity')}
                              className='form-control mb-2'
                              disabled={true}
                              value={quantity}
                              onChange={(e) => {}}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].quantity}</div>
                          </div>

                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t('Select Status')}</label>

                            <Select
                              name='SelectStatus'
                              id='SelectStatus'
                              placeholder={t('Select Status')}
                              isSearchable={true}
                              options={statusList}
                              value={selectedStatus}
                              onChange={(e: any) => {
                                setSelectedStatus(e)
                              }}
                              styles={{
                                container: (provided) => ({...provided, width: '100%'}),
                                control: (provided) => ({...provided, minHeight: 43}),
                              }}
                            />
                          </div>

                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>
                              {t('Reservation Date')}
                            </label>

                            <input
                              type='date'
                              name='reservationDate'
                              placeholder={t('Reservation Date')}
                              className='form-control mb-2'
                              onKeyDown={(e) => e.preventDefault()}
                              min={new Date().toISOString().split('T')[0]}
                              value={fromDate}
                              onChange={(e) => {
                                setFromFDate(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].quantity}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>{t('Selected Tour')}</label>
                            <Select
                              name='selectedTour'
                              id='selectedTour'
                              placeholder={t('Select Tour')}
                              isSearchable={true}
                              options={tourList}
                              value={selectedTour}
                              isDisabled={true}
                              styles={{
                                container: (provided) => ({...provided, width: '100%'}),
                                control: (provided) => ({...provided, minHeight: 43}),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <Link
                  to={getEncryptedRoute('../viewtourbookingdetails/', {menuId:menuId})}
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                  state={{bookingId: detailBookingId}}
                >
                  {t('Cancel')}
                </Link>

                <button
                  onClick={() => {
                    editBookingDetails()
                  }}
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                >
                  <span className='indicator-label'>{t('Save')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {BookingDetail}
